import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

// fetching
import useFetch from "Hooks/useFetch";
import IsLoading from "Components/RequestHandler/IsLoading";
import IsError from "Components/RequestHandler/IsError";
import { useParams } from "react-router-dom";

// inner componenys
import SuccessStoriesHeader from "./Components/SuccessStoriesHeader";
import SuccessStoryBody from "./Components/SuccessStoryBody";
import SucessStoryGallery from "./Components/SucessStoryGallery";

const SuccessStories = () => {
  const { slug } = useParams();
  const { data, error, loading, fetchData } = useFetch(`success-story/${slug}`);

  useEffect(() => {
    fetchData();
  }, [slug]);

  if (loading) return <IsLoading />;
  else if (error) return <IsError />;
  else if (data) {
    const successStory = data?.successStories;
    const galleryData = data?.successStories.gallery;
    const meta = data?.meta;
    return (
      <main>
        <Helmet>
          <title>{meta?.meta_title}</title>
          <meta name="description" content={meta?.meta_description} />
          <meta name="keywords" content={meta?.meta_keywords} />
        </Helmet>
        <SuccessStoriesHeader isInner={true} />
        <SuccessStoryBody data={successStory} />
        {galleryData.length !== 0 && <SucessStoryGallery data={galleryData} />}
        {/* <OtherSuccessStoriesSlider data={otherSuccessStories} /> */}
      </main>
    );
  }
};

export default SuccessStories;
